import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import Image from "../elements/Image";
import Header from "../layout/Header.js";
import { Link } from "react-router-dom";
import Modal from "../elements/Modal";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "display: inline-block",
    "flex-wrap: wrap",
    "tiles-wrap center-content",
    "border-style: solid",
    pushLeft && "push-left"
  );

  const divStyle = {
    margin: "0 auto",
    width: "805px",
  };

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  };
  // We organiseren één keer per maand een interactieve sessie. Over taal. Over cultuur. Over literatuur. Over geografie. Over geschiedenis. Doe mee en leer nieuwe dingen over Nederland en België en oefen je Nederlands. <br/><br/>
  //We hebben nu zes sessies achter de rug. Kijk <Link to="/previous-videos">hier</Link> de interviews met de docenten terug. De zevende sessie is op vrijdag 10 december om 16 uur (15 uur in Portugal).

  return (
    <section {...props} className={outerClasses}>
      <Header />
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom text-color-primary"
              data-reveal-delay="200"
            >
              Online Gastcolleges <br />
            </h1>

            <p
              className="m-0 mb-32 reveal-from-bottom "
              data-reveal-delay="400"
            >
              Studeer je Nederlands als vreemde taal of heb je Nederlands als
              vreemde taal gestudeerd? Heb je interesse in taal- en
              cultuurbemiddeling met het Nederlands? Doe dan mee met onze nieuwe
              reeks online gastcolleges!
              <br />
              <br />
              Vanaf oktober 2023 kun je deelnemen aan de interactieve sessies
              van de derde reeks online gastcolleges waarin zeven
              hooggespecialiseerde professionals boeiende inzichten geven in het
              dynamische beroep van tolken en vertalen. Zij zullen onder andere
              praten over hun carrière, hun achtergrond en de rol van het
              Nederlands in hun loopbaan. Na de presentatie wordt voldoende tijd
              voorzien, waarin iedereen de kans krijgt om vragen te stellen aan
              de gastdocent en om de andere deelnemers wat beter te leren
              kennen.
              <br />
              <br />
              De colleges zijn gratis. De Taalunie financiert dit project.
              Interesse? Hieronder kun je alvast het programma bekijken met een
              korte beschrijving van de gastdocent, het thema van het
              gastcollege, de datum en de vergaderlink.
              <br />
              <br />
              Kijk hier naar de video om te weten te komen hoe een typische dag
              eruitziet van de gastdocent. Zo leer je de docent alvast een
              beetje kennen en oefen je meteen je luistervaardigheid.
              <br />
              <br />
              <div
                className="hero-figure reveal-from-bottom illustration-element-01"
                data-reveal-value="20px"
                data-reveal-delay="600"
              >
                <Modal
                  id="video-modal"
                  show={videoModalActive}
                  handleClose={closeModal}
                  video={require("./../../assets/video/SabineBourgeois.mp4")}
                  videoTag="iframe"
                />
                <a
                  data-video={require("./../../assets/video/SabineBourgeois.mp4")}
                  href="#0"
                  aria-controls="video-modal"
                  onClick={openModal}
                >
                  <Image
                    className="has-shadow"
                    src={require("./../../assets/images/SabineBourgeois.png")}
                    alt="Hero"
                    width={1000}
                    height={900}
                  />
                </a>
              </div>
              <br></br>
              <div
                className="hero-figure reveal-from-bottom illustration-element-01"
                data-reveal-value="10px"
                data-reveal-delay="300"
              >
                <br />
                De serie online gastcolleges is bestemd voor (ex-)studenten
                Nederlands aan universiteiten en talenscholen in het
                Middellandse Zeegebied en heeft als doel de contacten tussen
                studenten, alumni en docenten Nederlands in dit gebied te
                versterken.
                <br />
                In 2021 hebben we zeven gastcolleges gegeven over taal,
                literatuur en cultuur. In 2022 kwamen vier alumni Nederlands van
                universiteiten in het Middellandse Zeegebied aan het woord, die
                praatten over hun carrière, hun achtergrond en opleiding en de
                rol van het Nederlands in hun loopbaan.
                <br />
                De interviews waarin de docenten iets vertellen over zichzelf en
                over het thema van hun college kun je
                <Link to="/previous-videos"> hier </Link>terugkijken. Antoinet
                Brink (Universiteit van Coimbra) coördineerde deze twee reeksen.
                <br />
                <br />
                De derde reeks wordt gecoördineerd door Elisabeth Braem,
                opleiding tolk/vertaler SSLMIT, Universiteit van Triëst/KU
                Leuven
                <br />
                <br />
                <strong>
                  20 oktober 2023 van 13:30-15:00 door Niels Timmermans
                </strong>
                <br />
                Woordvoerder van de Permanente Vertegenwoordiging van België bij
                de Europese Unie Thema gastcollege: journalistieke bemiddeling
                in een Europese context Vergaderlink: <br />
                <a href="https://bitly.ws/XuYW"> https://bitly.ws/XuYW</a>
                <br />
                <br />
                <strong>
                  17 november 2023 van 13:30-15:00 door Veronique Denis
                </strong>
                <br />
                Zelfstandig audiovisueel vertaler, gespecialiseerd in
                mediatoegankelijkheid bij Denis Media Access Services Thema
                gastcollege: Audiovisueel vertalen in een digitaal tijdperk
                Vergaderlink: <br />
                <a href="https://bitly.ws/XTxe"> https://bitly.ws/XTxe</a>
                <br />
                <br />
                <strong>
                  24 november 2023 van 13:30-15:00 door Krisztina Soós
                </strong>
                <br />
                Vertaler van juridische teksten, jurist en docent van de Károli
                Universiteit in Boedapest Thema gastcollege: Juridische
                vertaling: meer dan alleen woorden Vergaderlink: <br />
                <a href="https://bitly.ws/XTxI"> https://bitly.ws/XTxI</a>
                <br />
                <br />
                <strong>
                  19 januari 2024 van 13:30-15:00 door Alessandro Colagiovanni
                </strong>
                <br />
                Beëdigd tolk en vertaler
                (Spaans-Italiaans-Nederlands-Duits-Engels-Frans) gespecialiseerd
                in marketing en internationale criminaliteit Thema gastcollege:
                Forensisch tolken en de internationale criminaliteit in
                Nederland en Europa: <br />
                <a href=" https://bitly.ws/XTyh"> https://bitly.ws/XTyh</a>
                <br />
                <br />
                <strong>
                  16 februari 2024 van 13:30-15:00 door Heidi Salaets
                </strong>
                <br />
                Professor Italiaans, notitietechniek en tolkwetenschap aan de KU
                Leuven Campus Antwerpen, verantwoordelijk voor de
                onderzoeksgroep tolkwetenschap, gespecialiseerd in o.a. medisch
                tolken Thema gastcollege: Medisch tolken: bemiddelen in de
                gezondheidssector Vergaderlink: <br />
                <a href="https://bitly.ws/XTza"> https://bitly.ws/XTza</a>
                <br />
                <br />
                <strong>
                  22 maart 2023 van 13:30-15:00 door Alric van den Broek
                </strong>
                <br />
                Zelfstandig juridisch- en conferentietolk en beëdigd vertaler
                Engels en Duits, gespecialiseerd in (juridisch) tolken op de
                vrije markt. Daarnaast ook conferentietolk voor de Europese
                Unie. Thema gastcollege: De uitdagingen van tolken op de vrije
                markt. Vergaderlink: <br />
                <a href=" https://bitly.ws/XTzR"> https://bitly.ws/XTzR</a>
                <br />
                <br />
                <strong>
                  19 april 2024 van 13:30-15:00 door Sabine Bourgeois
                </strong>
                <br />
                Zelfstandig conferentietolk gespecialiseerd in online tolken
                vanop afstand en oprichter van online tolkplatform caPPisco.
                Thema gastcollege: Simultaan tolken vanop afstand: nieuwe
                mogelijkheden post-Covid Vergaderlink: <br />
                <a href="https://bitly.ws/YLUG"> https://bitly.ws/YLUG</a>
                <br />
                <br />
                <strong>11 oktober 2024 van 10:00-13:00:</strong> hybride
                slotbijeenkomst online en in loco aan de Universiteit van Triëst
                over de professionaliseringsaspecten van het Nederlands Drie
                gastdocenten van de reeks, Niels Timmermans, Alessandro
                Colagiovanni en Krisztina Soós, zullen naar Trieste komen, om
                samen in gesprek te treden tijdens een rondetafelgesprek over
                het overbruggen van taal- en cultuurverschillen en de impact van
                nieuwe technologieën op de evolutie van werken met het
                Nederlands. Na een korte pauze zullen enkele studenten van
                Triëst een interview afnemen met de gastdocenten over het
                overbruggen van de afstand tussen de universiteit en de
                arbeidsmarkt. We sluiten de bijeenkomst af met een Q&A, waarbij
                iedereen de kans krijgt om rechtstreeks vragen te stellen aan de
                gastdocenten. Jullie kunnen het evenement volgen via deze link:
                <a href="https://t.ly/6UOXo"> https://t.ly/6UOXo</a>
                <div className={tilesClasses} style={divStyle}>
                <Image
                  className="has-shadow"
                  src={require("./../../assets/images/1.png")}
                  alt="Hero"
                  width={400}
                  height={400}
                  />
               
                <Image
                  className="has-shadow"
                  src={require("./../../assets/images/2.png")}
                  alt="Hero"
                  width={400}
                  height={400}
                />
              </div>
              </div>
            </p>
          </div>

          <div>
            <div className={tilesClasses} style={divStyle}>
              <a style={{ width: "50%" }} href="https://taalunie.org/">
                <Image
                  src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
                  alt="Open"
                  width={100}
                  height={52}
                />
              </a>{" "}
              <Image
                src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
                alt="Open"
                width={0}
                height={0}
              />
              <a style={{ width: "50%" }} href="http://mediterraned.org/">
                <Image
                  src={require("./../../assets/images/Mediterraned.png")}
                  alt="Open"
                  width={100}
                  height={52}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
